/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response to update the email of a person
 * @export
 * @interface UpdateEmailPwrResponse
 */
export interface UpdateEmailPwrResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailPwrResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailPwrResponse
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmailPwrResponse
     */
    isFavorite?: boolean;
}

/**
 * Check if a given object implements the UpdateEmailPwrResponse interface.
 */
export function instanceOfUpdateEmailPwrResponse(value: object): value is UpdateEmailPwrResponse {
    return true;
}

export function UpdateEmailPwrResponseFromJSON(json: any): UpdateEmailPwrResponse {
    return UpdateEmailPwrResponseFromJSONTyped(json, false);
}

export function UpdateEmailPwrResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmailPwrResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'note': json['note'] == null ? undefined : json['note'],
        'isFavorite': json['isFavorite'] == null ? undefined : json['isFavorite'],
    };
}

export function UpdateEmailPwrResponseToJSON(json: any): UpdateEmailPwrResponse {
    return UpdateEmailPwrResponseToJSONTyped(json, false);
}

export function UpdateEmailPwrResponseToJSONTyped(value?: UpdateEmailPwrResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'note': value['note'],
        'isFavorite': value['isFavorite'],
    };
}

